<template>
  <router-view />
</template>

<style lang="scss">
// Import Main styles for this application
@import 'assets/scss/style';
</style>
